module.exports = __webpack_public_path__ + "static/logo-f348feb75be9b6512c27b8ceb7712ce4.svg";